import { ReactNode, memo } from 'react';

import styles from './FixedWidthContentContainer.module.scss';

interface FixedWidthContentContainerProps {
  readonly children: ReactNode;
}

/**
 * Utility container to prevent the content pages to expand too much when viewed
 * on wide screen monitors.
 */
const FixedWidthContentContainer = memo(function FixedWidthContentContainer({
  children,
}: FixedWidthContentContainerProps) {
  return <div className={styles.container}>{children}</div>;
});

export default FixedWidthContentContainer;
